export default __webpack_public_path__ + "static/media/h5-bg6.492acc61.png";